import Collection from '../collection';
import Grid from './grid';
import View from './view';





export default View.extend( {

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        const { datatables } = this.options;
        if (datatables)
            options.sorted = Grid.sort( { sort: this.sort_, direction: this.direction_, }, 
                datatables, new Collection() ),
            options.filtered = new Collection(),
            options.dest = new Collection();
        else
            options.sorted = Promise.resolve();
    },

    template: 'pick.objects',

    page_: 1,

    search_: '',

    sort_: 'name',

    direction_: 'asc',

    serialize() {
        const { sorted, filtered, dest, objects, } = this.options;
        return sorted.then( sorted => {
            if (sorted)
                Grid.filter( { search: this.search_, page: this.page_, limit: 10, }, 
                    null, // cluster
                    sorted, filtered, dest );

            return {
                datatables: dest,
                objects,
                searchString: this.search_,
                dataTablesSort: this.sort_, dataTablesDirection: this.direction_,
            }
        } );
    },

    events: {

        'click .datatables-grid .-sort'({currentTarget}) {
            const { direction, sort, } = currentTarget.dataset;
            const { datatables, sorted, } = this.options;

            return this.page_ = 1, this.sort_ = sort, this.direction_ = direction, 
                sorted.then( sorted => Grid.sort( { sort, direction, }, datatables, sorted, ) )
                    .then( () => this.render() )
                    .then( () => this.focus() );
        },

    },

    [View.event( 'ObjectsGrid:action:default' )](index, object) {
        if (!this.options.multiple)
            this.trigger( 'modal:accept', this.chosen_ = object );
    },

    [View.event( 'ObjectsGrid:activate' )](index, object) {
        this.chosen_ = object;
    },

    [View.event( 'ObjectsGrid:deactivate' )]() {
        this.chosen_ = null;
    },

    [View.event( 'DataTablesPaging:page')](page) {
        return this.page_ = page, this.render(); 
    },

    [View.event( 'DataTablesSearch:search')](search) {
        return this.search_ = search, this.page_ = 1, this.render();
    },

    [View.event( 'DataTables:activate' )](index) {
        return this.Objects.render().then( () => this.Objects.focus() );
    },

    [View.event( 'DataTables:deactivate' )]() {
        return this.Objects.render();
    },

}, {

    // todo sorting
    of( { datatables, objects, ...options } ) {
        if (datatables instanceof Array)
            datatables = new Collection( datatables );

        if (objects instanceof Array)
            objects = new Collection( objects );

        const Class = this;
        return new Class( { datatables, objects, ...options } );
    },

} );



// WEBPACK FOOTER //
// ./src/js/view/pick.objects.js